import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { CompanyVendorPayment } from './company-vendor-payment';
import { Transaction } from './transaction';

export class Invoice extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static InvoiceProperties: (
    | {
        property: keyof Invoice;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof Invoice;
        type: 'alias';
      }
    | {
        property: keyof Invoice;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'payUuid', type: 'column', dataType: 'string' },
    { property: 'totalAmt', type: 'column', dataType: 'number' },
    { property: 'paidDate', type: 'column', dataType: 'date' },
    { property: 'status', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'associatedClients', type: 'alias' },
    { property: 'recentTransactionReferenceNumber', type: 'alias' },

    { property: 'Transactions', model: 'Transaction', type: 'association' },
    {
      property: 'CompanyVendorPayments',
      model: 'CompanyVendorPayment',
      type: 'association'
    },
    {
      property: 'RecentTransaction',
      model: 'RecentTransaction',
      type: 'association'
    }
  ];

  static {
    Invoice.InvoiceProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        Invoice.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        Invoice.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        Invoice.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(InvoiceObject: Partial<Invoice>) {
    super();

    Invoice.InvoiceProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = InvoiceObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  payUuid?: string;
  totalAmt?: number;
  paidDate?: Date;
  status?: string;
  createdAt?: Date;
  updatedAt?: Date;

  //Alias column
  associatedClients?: string;
  recentTransactionReferenceNumber?: string;

  Transactions?: Transaction[];
  CompanyVendorPayments?: CompanyVendorPayment[];
  RecentTransaction?: Transaction;
}
